export enum LogLevel {
  Debug = 'DEBUG',
  Info = 'INFO',
  Warning = 'WARN',
  Error = 'ERROR',
  Report = 'REPORT',
}
